import {useEffect} from "react";
import {getAnalytics} from "@zaaaz/shared";

export function GoogleAnalytics() {
  useEffect(() => {
    getAnalytics().then((r) => {
      if(!r.html) return;
      const wrap = document.createElement("div");
      wrap.innerHTML = r.html;
      wrap.querySelectorAll("script").forEach((old) => {
        const s = document.createElement("script");
        if(old.src) s.src = old.src;
        else s.textContent = old.textContent;
        if(old.async) s.async = true;
        document.head.appendChild(s);
      });
      wrap.querySelectorAll("noscript").forEach((n) => document.head.appendChild(n.cloneNode(true)));
    }).catch(() => {});
  }, []);
  return null;
}
